<div class="flex flex-col w-full h-full">
  <!-- Loading State -->
  <div *ngIf="!isPageReady" class="flex items-center justify-center h-full">
    <i class="pi pi-spin pi-spinner text-4xl text-primary"></i>
  </div>

  <div *ngIf="isPageReady" class="flex flex-col h-full gap-3">
    <!-- Toolbar -->
    <div class="flex items-center gap-3">
      <span class="text-sm text-muted-color">
        {{ unreadCount }} unread
      </span>
      <div class="flex-grow"></div>
      <p-button *ngIf="unreadCount > 0" label="Mark All Read" icon="pi pi-check" [text]="true" size="small"
        (onClick)="onMarkAllRead()" />
      <p-button label="Delete Read" icon="pi pi-trash" [text]="true" size="small" severity="danger"
        (onClick)="onDeleteAllRead()" [disabled]="readCount === 0" />
    </div>

    <!-- Two-column layout -->
    <div class="flex flex-grow min-h-0 border border-surface rounded-lg overflow-hidden">

      <!-- Left: Notification List -->
      <div class="inbox-list w-2/5 border-r border-surface overflow-y-auto bg-surface-0">
        <div *ngIf="inAppNotifications.length === 0"
          class="flex flex-col items-center justify-center h-full text-muted-color p-6">
          <i class="pi pi-inbox text-4xl mb-2 opacity-40"></i>
          <span class="text-sm">No notifications</span>
        </div>

        <div *ngFor="let n of inAppNotifications"
          class="inbox-item flex items-start gap-3 px-4 py-3 border-b border-surface"
          [class.selected]="selectedNotification === n"
          [class.unread]="!n.wasRead"
          (click)="selectNotification(n)">

          <!-- Unread dot -->
          <i *ngIf="!n.wasRead" class="pi pi-circle-fill text-primary mt-1" style="font-size: 8px"></i>
          <i *ngIf="n.wasRead" class="mt-1" style="width: 8px"></i>

          <!-- Content -->
          <div class="flex-grow min-w-0">
            <div class="item-event text-sm truncate">{{ getEventName(n) }}</div>
            <div class="text-xs text-muted-color mt-0.5">{{ formatRelativeDate(n.createdTs) }}</div>
          </div>

          <!-- Delete (hover) -->
          <button class="delete-btn p-0 border-0 bg-transparent text-muted-color hover:text-red-500 cursor-pointer mt-0.5"
            (click)="onDelete(n); $event.stopPropagation()">
            <i class="pi pi-trash text-sm"></i>
          </button>
        </div>
      </div>

      <!-- Right: Message Preview -->
      <div class="message-pane w-3/5 flex flex-col overflow-y-auto bg-surface-50">
        <div *ngIf="selectedNotification" class="flex flex-col h-full">
          <!-- Message header -->
          <div class="flex items-center justify-between px-5 py-3 border-b border-surface bg-surface-0">
            <span class="text-xs text-muted-color">
              {{ selectedNotification.createdTs | date:'medium' }}
            </span>
            <div class="flex items-center gap-1">
              <p-button icon="pi pi-reply" [text]="true" size="small" pTooltip="Reply" tooltipPosition="bottom"
                (onClick)="onReplyByEmail()" />
              <p-button icon="pi pi-forward" [text]="true" size="small" pTooltip="Forward" tooltipPosition="bottom"
                (onClick)="onForwardByEmail()" />
            </div>
          </div>
          <!-- Message body -->
          <div class="px-5 py-4 flex-grow">
            <div [innerHTML]="selectedNotification.notificationMessage" class="notification-body"></div>
          </div>
        </div>

        <div *ngIf="!selectedNotification" class="flex flex-col items-center justify-center h-full text-muted-color">
          <i class="pi pi-envelope text-4xl mb-2 opacity-30"></i>
          <span class="text-sm">Select a message</span>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex justify-end">
      <p-button label="Close" icon="pi pi-times" size="small" (onClick)="onClose()" />
    </div>
  </div>

  <!-- Local confirm dialog for Delete All Read -->
  <p-confirmDialog key="inbox" [closable]="false" [baseZIndex]="20000"></p-confirmDialog>
</div>
